import { BASE_URL_V2 } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  PATCH: 'TEACHER_BADGE_PATCH',
  PATCH_SUCCESS: 'TEACHER_BADGE_PATCH_SUCCESS',
  PATCH_FAILURE: 'TEACHER_BADGE_PATCH_FAILURE',
};

export const patch = actions.patch(
  badgeId => `${BASE_URL_V2}/students/student-badges/${badgeId}/`,
  {
    PENDING: ACTIONS.PATCH,
    SUCCESS: ACTIONS.PATCH_SUCCESS,
    FAILURE: ACTIONS.PATCH_FAILURE,
  },
);
